import { Button, Dropdown, Flex, MenuProps, Space } from 'antd';
import { CrudFilters, HttpError, useCan, useNavigation } from '@refinedev/core';
import { IUser } from 'interfaces/users';
import {
  IUsersFilterForm,
  UsersListFilter
} from './components/list/list-filter';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { PlusOutlined } from '@ant-design/icons';
import { UsersListTable } from './components/list/list-table';
import { useCallback } from 'react';
import { useTable } from '@refinedev/antd';

export const UserList = () => {
  const canCreateUsers = useCan({ resource: 'users', action: 'create' });
  const canCreateBulkUsers = useCan({
    resource: 'bulk_users',
    action: 'create'
  });
  const canCreateBulkSuspends = useCan({
    resource: 'bulk_user_suspends',
    action: 'create'
  });

  const { tableProps, searchFormProps } = useTable<
    IUser,
    HttpError,
    IUsersFilterForm
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { name, email, cpf, estacio_id } = params;

      filters.push(
        {
          field: 'filter[name]',
          operator: 'eq',
          value: name
        },
        {
          field: 'filter[email]',
          operator: 'eq',
          value: email
        },
        {
          field: 'filter[cpf]',
          operator: 'eq',
          value: cpf?.replace(/\D/g, '')
        },
        {
          field: 'filter[by_estacio_id]',
          operator: 'eq',
          value: estacio_id
        }
      );

      return filters;
    }
  });

  const router = useNavigation();

  const items: MenuProps['items'] = [
    canCreateUsers.data?.can
      ? {
          label: 'Novo aluno',
          key: 'create'
        }
      : null,
    canCreateBulkUsers.data?.can
      ? {
          label: 'Adicionar alunos em lote',
          key: 'bulk_users'
        }
      : null,
    canCreateBulkSuspends.data?.can
      ? {
          label: 'Suspender alunos em lote',
          key: 'bulk_user_suspends'
        }
      : null
  ].filter((item): item is NonNullable<typeof item> => item !== null);

  const handleMenuClick: MenuProps['onClick'] = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      switch (e.key) {
        case 'create': {
          router.create('users');
          break;
        }

        case 'bulk_users': {
          router.create('bulk_users');
          break;
        }

        case 'bulk_user_suspends': {
          router.create('bulk_user_suspends');
          break;
        }
      }
    },
    [router]
  );

  const menuProps = {
    items,
    onClick: handleMenuClick
  };

  return (
    <ListLayout
      title="Alunos"
      headerActions={
        <Flex>
          <Dropdown menu={menuProps}>
            <Button type="primary" disabled={items.length === 0}>
              <Space>
                <PlusOutlined />
                Ações
              </Space>
            </Button>
          </Dropdown>
        </Flex>
      }
    >
      <UsersListFilter searchFormProps={searchFormProps} />
      <UsersListTable tableProps={tableProps} />
    </ListLayout>
  );
};
